export const color = (var_name) => {
    const style = getComputedStyle(document.body);
    return style.getPropertyValue(var_name);
};